module.exports = __webpack_public_path__ + "img/dues-and-subs.3de8b09e.svg";